import styled from 'styled-components';

export const PageWrapper = styled.div`
  min-height: 100vh;
  background: linear-gradient(to bottom right, #000, #0f172a, #000);
  color: #fff;
`;

export const InnerWrapper = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 24px 24px;
`;

export const StickyHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  position: sticky;
  top: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(10px);
  z-index: 10;
  padding: 16px;
  border-radius: 12px;
`;

export const HeaderTitle = styled.h1`
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
`;

export const CreateBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  background: rgba(6, 182, 212, 0.2);
  color: #67e8f9;
  text-decoration: none;
  transition: background 0.2s;
  &:hover {
    background: rgba(6, 182, 212, 0.3);
  }
`;

export const ContractGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const GridHeader = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 1.5fr 0.9fr 0.7fr 1fr 0.8fr 0.9fr 0.9fr 0.9fr 1fr;
  gap: 16px;
  align-items: center;
  padding: 12px 16px;
  font-size: 12px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.7);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 1px solid rgba(6, 182, 212, 0.2);

  /* Align header labels with the way row content is aligned */
  & > span:nth-child(1) {
    justify-self: flex-start;
  }
  & > span:nth-child(2) {
    justify-self: flex-start;
  }
  & > span:nth-child(6),
  & > span:nth-child(7),
  & > span:nth-child(8),
  & > span:nth-child(9) {
    justify-self: center;
  }
  & > span:nth-child(10) {
    justify-self: flex-end;
  }
`;

export const ContractRow = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 1.5fr 0.9fr 0.7fr 1fr 0.8fr 0.9fr 0.9fr 0.9fr 1fr;
  gap: 16px;
  align-items: center;
  padding: 14px 16px;
  border-radius: 12px;
  margin-bottom: 8px;
  transition: all 0.2s;
  ${({ $pending }) =>
    $pending
      ? `
    background: rgba(6, 182, 212, 0.1);
    border: 1px solid rgba(6, 182, 212, 0.4);
    box-shadow: 0 0 25px rgba(0, 247, 210, 0.25);
  `
      : `
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(6, 182, 212, 0.2);
    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }
  `}
`;

export const ContractId = styled.div`
  font-size: 0.875rem;
  opacity: 0.7;
`;

export const ContractName = styled.div`
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const StatusBadge = styled.span`
  display: inline-block;
  padding: 4px 12px;
  border-radius: 9999px;
  font-size: 12px;
  ${({ $status }) => {
    switch ($status) {
      case 'Approved':
        return `
          background: rgba(34, 197, 94, 0.2);
          color: #86efac;
          border: 1px solid rgba(34, 197, 94, 0.6);
        `;
      case 'Rejected':
        return `
          background: rgba(239, 68, 68, 0.2);
          color: #fca5a5;
          border: 1px solid rgba(239, 68, 68, 0.6);
        `;
      case 'Pending':
      default:
        return `
          background: rgba(6, 182, 212, 0.2);
          color: #67e8f9;
          border: 1px solid rgba(6, 182, 212, 0.6);
        `;
    }
  }}
`;

export const LoadingText = styled.div`
  grid-column: 1 / -1;
  text-align: center;
  padding: 48px;
  opacity: 0.7;
`;

export const SignaturesTooltip = styled.div`
  pointer-events: none;
  position: absolute;
  left: 50%;
  top: 100%;
  z-index: 20;
  margin-top: 8px;
  padding: 8px 12px;
  border-radius: 12px;
  border: 1px solid rgba(6, 182, 212, 0.3);
  background: rgba(0, 0, 0, 0.8);
  font-size: 12px;
  color: #67e8f9;
  backdrop-filter: blur(8px);
  box-shadow: 0 0 30px rgba(0, 247, 210, 0.35);
  white-space: nowrap;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.2s;
`;

export const SignaturesWrap = styled.div`
  position: relative;
  cursor: help;
  color: #67e8f9;
  &:hover ${SignaturesTooltip} {
    opacity: 1;
  }
`;

export const UpdatedDate = styled.div`
  font-size: 0.875rem;
  opacity: 0.7;
`;

export const ActionsRow = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  align-items: center;
`;

export const ViewBtn = styled.button`
  padding: 6px 12px;
  border-radius: 12px;
  font-size: 14px;
  cursor: pointer;
  border: 1px solid rgba(6, 182, 212, 0.3);
  background: rgba(6, 182, 212, 0.1);
  color: #67e8f9;
  transition: all 0.2s;
  &:hover {
    background: rgba(6, 182, 212, 0.25);
    box-shadow: 0 0 20px rgba(0, 247, 210, 0.25);
  }
`;

export const ApproveBtn = styled.button`
  padding: 6px 12px;
  border-radius: 12px;
  font-size: 14px;
  cursor: pointer;
  border: 1px solid rgba(34, 197, 94, 0.4);
  background: linear-gradient(to right, rgba(34, 197, 94, 0.3), rgba(16, 185, 129, 0.3));
  color: #bbf7d0;
  transition: all 0.2s;
  &:hover {
    background: linear-gradient(to right, rgba(34, 197, 94, 0.4), rgba(16, 185, 129, 0.4));
    box-shadow: 0 0 25px rgba(34, 197, 94, 0.35);
  }
`;

export const RejectBtn = styled.button`
  padding: 6px 12px;
  border-radius: 12px;
  font-size: 14px;
  cursor: pointer;
  border: 1px solid rgba(239, 68, 68, 0.4);
  background: linear-gradient(to right, rgba(239, 68, 68, 0.3), rgba(244, 63, 94, 0.3));
  color: #fecaca;
  transition: all 0.2s;
  &:hover {
    background: linear-gradient(to right, rgba(239, 68, 68, 0.4), rgba(244, 63, 94, 0.4));
    box-shadow: 0 0 25px rgba(239, 68, 68, 0.35);
  }
`;

export const ActionsCol = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 8px;
  justify-content: flex-end;
  align-items: center;
`;

export const ActionsMenuButton = styled.button`
  padding: 6px;
  border-radius: 999px;
  border: 1px solid rgba(148, 163, 184, 0.5);
  background: rgba(15, 23, 42, 0.8);
  color: #e2e8f0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s, box-shadow 0.15s, transform 0.05s;

  &:hover {
    background: rgba(30, 64, 175, 0.7);
    box-shadow: 0 0 18px rgba(56, 189, 248, 0.35);
  }

  &:active {
    transform: scale(0.96);
  }
`;

export const ActionsMenu = styled.div`
  position: absolute;
  right: 0;
  top: calc(100% + 6px);
  min-width: 140px;
  padding: 6px;
  border-radius: 12px;
  background: rgba(15, 23, 42, 0.98);
  border: 1px solid rgba(6, 182, 212, 0.3);
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.9);
  z-index: 20;
`;

export const ActionsMenuItem = styled.button`
  width: 100%;
  padding: 6px 10px;
  border-radius: 8px;
  border: none;
  background: transparent;
  color: #e2e8f0;
  font-size: 13px;
  text-align: left;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    background: rgba(15, 118, 110, 0.5);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const HashLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #67e8f9;
  text-decoration: none;
  font-size: 13px;
  transition: opacity 0.2s;
  &:hover {
    opacity: 0.9;
    text-decoration: underline;
  }
`;

export const HashCell = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const TypeCell = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CellText = styled.span`
  font-size: 0.875rem;
  opacity: 0.9;
`;

export const SidebarHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const SidebarCloseBtn = styled.button`
  padding: 4px 12px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #fff;
  cursor: pointer;
  font-size: 12px;
  transition: opacity 0.2s;
  &:hover {
    opacity: 0.9;
  }
`;

export const ApprovalSidebar = styled.div`
  position: fixed;
  right: 0;
  top: 0;
  height: 100%;
  width: 420px;
  z-index: 99999;
  background: #0a0f1a;
  border-left: 1px solid rgba(6, 182, 212, 0.3);
  padding: 24px;
  overflow-y: auto;
  box-shadow: -8px 0 32px rgba(0, 0, 0, 0.5);
`;

export const SidebarDetailTitle = styled.h3`
  font-size: 1rem;
  font-weight: 600;
  margin: 0 0 16px 0;
  color: #67e8f9;
`;

export const SidebarDetailSection = styled.div`
  margin-bottom: 20px;
`;

export const SidebarDetailRow = styled.div`
  margin-bottom: 10px;
  font-size: 14px;
`;

export const SidebarDetailLabel = styled.span`
  display: block;
  font-size: 12px;
  opacity: 0.7;
  margin-bottom: 2px;
`;

export const SidebarDetailValue = styled.span`
  color: #e2e8f0;
`;

export const SidebarHashLink = styled.a`
  display: block;
  font-size: 12px;
  color: #67e8f9;
  word-break: break-all;
  margin-bottom: 8px;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

export const SidebarHashList = styled.div`
  margin-top: 8px;
`;

export const HeaderActions = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const AddSafeboxBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: 1px solid rgba(34, 197, 94, 0.4);
  background: linear-gradient(to right, rgba(34, 197, 94, 0.2), rgba(16, 185, 129, 0.2));
  color: #86efac;
  transition: all 0.2s;
  &:hover {
    background: linear-gradient(to right, rgba(34, 197, 94, 0.3), rgba(16, 185, 129, 0.3));
    box-shadow: 0 0 20px rgba(34, 197, 94, 0.25);
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
`;

export const ModalBox = styled.div`
  background: #0f172a;
  border: 1px solid rgba(6, 182, 212, 0.2);
  border-radius: 16px;
  padding: 24px;
  width: 480px;
  max-height: 90vh;
  overflow-y: auto;
`;

export const ModalTitle = styled.h3`
  font-weight: 500;
  margin: 0 0 8px 0;
`;

export const FormInput = styled.input`
  width: 100%;
  padding: 12px 16px;
  background: rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  color: #fff;
  font-size: 14px;
  margin-bottom: 12px;

  &::placeholder {
    color: rgba(255, 255, 255, 0.5);
  }
`;

export const FormTextarea = styled.textarea`
  width: 100%;
  padding: 12px 16px;
  background: rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  color: #fff;
  font-size: 14px;
  min-height: 80px;
  margin-bottom: 12px;
  resize: vertical;

  &::placeholder {
    color: rgba(255, 255, 255, 0.5);
  }
`;

export const FormLabel = styled.label`
  display: block;
  font-size: 12px;
  opacity: 0.7;
  margin-bottom: 4px;
`;

export const FormGroup = styled.div`
  margin-bottom: 16px;
`;

export const OTPProgressBar = styled.div`
  width: 100%;
  height: 8px;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 999px;
  overflow: hidden;
  margin-bottom: 8px;
`;

export const OTPProgressFill = styled.div`
  height: 100%;
  background: linear-gradient(to right, #06b6d4, #0ea5e9);
  border-radius: 999px;
  transition: width 0.2s;
`;

export const OTPInput = styled.input`
  width: 100%;
  padding: 12px 16px;
  background: rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  color: #fff;
  text-align: center;
  letter-spacing: 0.5em;
  font-size: 18px;
  margin-bottom: 16px;

  &::placeholder {
    color: rgba(255, 255, 255, 0.5);
  }
`;

export const ModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
`;

export const BtnGhost = styled.button`
  padding: 8px 16px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  background: rgba(255, 255, 255, 0.05);
  color: #fff;
  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
    pointer-events: none;
  }
`;

export const BtnPrimary = styled.button`
  padding: 8px 16px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: 1px solid rgba(6, 182, 212, 0.4);
  background: linear-gradient(to right, rgba(6, 182, 212, 0.3), rgba(14, 165, 233, 0.3));
  color: #fff;
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
